module.exports = __webpack_public_path__ + "img/web-P4-2-2.04ab6066.png";